const date_sort = ( a,b, date_field ) => {
    // Turn your strings into dates, and then subtract them
    // to get a value that is either negative, positive, or zero.
    return new Date(b[date_field]) - new Date(a[date_field]);
}

export default date_sort;